// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sBmLueKjW2IScxaHKU16{padding:16px}.ncI_HO8CDpSMsZcU6xZD{margin-bottom:16px;border-radius:4px}.GLckLi45LcWbkrfX05BU{cursor:pointer}
`, "",{"version":3,"sources":["webpack://./src/layouts/components/notification-sidenav/notifications-tab.module.scss"],"names":[],"mappings":"AAAA,sBACI,YAAa,CAChB,sBAGG,kBAAmB,CACnB,iBAAkB,CACrB,sBAEG,cAAe","sourcesContent":[".portal-notifications-wrapper {\r\n    padding: 16px;\r\n}\r\n\r\n.portal-notifications-card {\r\n    margin-bottom: 16px;\r\n    border-radius: 4px;\r\n}\r\n.cursor-pointer {\r\n    cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"portal-notifications-wrapper": `sBmLueKjW2IScxaHKU16`,
	"portal-notifications-card": `ncI_HO8CDpSMsZcU6xZD`,
	"cursor-pointer": `GLckLi45LcWbkrfX05BU`
};
export default ___CSS_LOADER_EXPORT___;
